import { render, staticRenderFns } from "./ActivityDialog.vue?vue&type=template&id=287e8cf3&scoped=true"
import script from "./ActivityDialog.vue?vue&type=script&lang=js"
export * from "./ActivityDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivityDialog.vue?vue&type=style&index=0&id=287e8cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e8cf3",
  null
  
)

export default component.exports